<template>
  <div class="no-access">
    <img src="@/assets/images/icons/no-access.svg" />
    <p>
      {{ $t('global.no_access_error') }}
    </p>
    <a
      href="https://api.whatsapp.com/send?phone=966920007031&text=I%20need%20support%20in%20call%20center%20service%20billing"
      target="_blank"
    >
      {{ $t('global.customer_support') }}
    </a>
  </div>
</template>

<script>
  import { mapState } from 'pinia';
  import { userDetailsStore } from '@/stores/auth/user-details.store';

  export default {
    name: 'NoAccessView',
    computed: {
      ...mapState(userDetailsStore, ['isActiveBilling']),
    },
    created() {
      if (this.isActiveBilling) {
        this.$router.push({ name: 'dashboard' });
      }
    },
  };
</script>

<style lang="scss" scoped>
  .no-access {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: var(--error500);
    width: 100%;
    height: 100%;
    padding: 16px;
    gap: 24px;

    img {
      width: 72px;
      height: 72px;
    }

    p {
      text-align: center;
      font-size: 24px;
      white-space: pre-line;
    }

    a,
    a:visited {
      padding: 8px 24px;
      border-radius: 8px;
      text-decoration: none;
      color: #fff;
      background-color: var(--color-base-500);

      &:hover,
      &:active {
        background-color: color-mix(in srgb, var(--color-base-500) 100%, #000 10%);
      }
    }
  }
</style>
